import { useEffect } from "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdPassword } from "react-icons/md";
//#region src/modules/AuthWrapper2/components/Login/views/NewPasswordSuccess.tsx
function NewPasswordSuccess({ onDone }) {
	useEffect(() => {
		const loginTimeout = setTimeout(onDone, 5e3);
		return () => clearTimeout(loginTimeout);
	}, []);
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-xl flex flex-col items-center",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "gap-y-base flex flex-col items-center",
			children: [/* @__PURE__ */ jsx(Icon, {
				Icon: MdPassword,
				size: "xxl",
				color: "positive"
			}), /* @__PURE__ */ jsx("div", {
				className: "text-center text-lg font-medium",
				children: "Password successfully modified"
			})]
		}), /* @__PURE__ */ jsx(Button, {
			variant: "main",
			onClick: onDone,
			children: "Continue Logging in"
		})]
	});
}
//#endregion
export { NewPasswordSuccess };

//# sourceMappingURL=NewPasswordSuccess.js.map